import createCache from '@emotion/cache';

export const emotionCache = createCache({
  key: 'my-prefix-key',
  nonce: document.getElementById("nonce")!.textContent ?? ""
});